/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AttachmentEntityTypeEnum = "contacts" | "containers" | "messages" | "shipments" | "%future added value";
export type infoCreateFolderInput = {
    clientMutationId?: string | null;
    entityType: AttachmentEntityTypeEnum;
    entitySlug: string;
    name: string;
    parentType: string;
};
export type FoldersCardNewMutationVariables = {
    input: infoCreateFolderInput;
};
export type FoldersCardNewMutationResponse = {
    readonly infoCreateFolder: {
        readonly clientMutationId: string | null;
    } | null;
};
export type FoldersCardNewMutation = {
    readonly response: FoldersCardNewMutationResponse;
    readonly variables: FoldersCardNewMutationVariables;
};



/*
mutation FoldersCardNewMutation(
  $input: infoCreateFolderInput!
) {
  infoCreateFolder(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoCreateFolderPayload",
    "kind": "LinkedField",
    "name": "infoCreateFolder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FoldersCardNewMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FoldersCardNewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c7107d8f2be21e2c4ad812fca4a0e9e0",
    "id": null,
    "metadata": {},
    "name": "FoldersCardNewMutation",
    "operationKind": "mutation",
    "text": "mutation FoldersCardNewMutation(\n  $input: infoCreateFolderInput!\n) {\n  infoCreateFolder(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a9d2abe450c4cc2398e1db486207329c';
export default node;
